<template>
  <div class="content mts-page">
    <!-- Filter Section -->
    <div class="row-data mts-toolbar-card">
      <div class="mts-card-head">
        <div>
          <p class="mts-card-title">Thống kê phiếu thu</p>
          <p class="mts-card-subtitle">Lấy danh sách lớp/nhóm kèm tổng hợp tài chính</p>
        </div>
      </div>

      <el-form
        ref="searchFormRef"
        :model="filter"
        label-position="top"
        class="mts-form-grid"
      >
        <el-form-item label="Khoảng thời gian" class="mts-form-item">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="Từ ngày"
            end-placeholder="Đến ngày"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 250px"
            @change="fetchData"
          />
        </el-form-item>

        <el-form-item v-if="filter.targetType !== 'PACKAGE'" :label="filter.targetType === 'CLASS' ? 'Trạng thái lớp' : 'Trạng thái nhóm'" class="mts-form-item">
          <el-select
            v-model="filter.statusTargetType"
            placeholder="Tất cả"
            clearable
            style="width: 150px"
            @change="fetchData"
          >
            <el-option label="Đang hoạt động" :value="true" />
            <el-option label="Đã ngừng" :value="false" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="filter.targetType === 'PACKAGE'" label="Tên gói" class="mts-form-item">
          <el-input
            v-model="filter.packageName"
            placeholder="Tìm kiếm gói..."
            clearable
            style="width: 220px"
            @keyup.enter.native="fetchData"
            @clear="fetchData"
          >
            <template #append>
              <el-button icon="el-icon-search" @click="fetchData" />
            </template>
          </el-input>
        </el-form-item>

        <el-form-item v-if="filter.targetType === 'CLASS'" label="Khối" class="mts-form-item">
          <el-select
              v-model="filter.idGrade"
              placeholder="Tất cả"
              clearable
              style="width: 140px"
              @change="fetchData"
          >
            <el-option
                v-for="item in gradeOfSchoolList"
                :key="item.id"
                :value="item.id"
                :label="item.gradeName"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Trạng thái học sinh" class="mts-form-item">
          <el-select
              v-model="filter.kidStatus"
              placeholder="Tất cả"
              clearable
              style="width: 150px"
              @change="fetchData"
          >
            <el-option
                v-for="item in kidStatusListExcel"
                :key="item.key"
                :value="item.key"
                :label="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Trạng thái phiếu" class="mts-form-item">
          <el-select
            v-model="filter.status"
            placeholder="Tất cả"
            clearable
            style="width: 160px"
            @change="fetchData"
          >
            <el-option label="Chưa đóng" value="UNPAID" />
            <el-option label="Đóng một phần" value="PARTIALLY_PAID" />
            <el-option label="Đóng đủ 100%" value="FULLY_PAID" />
            <el-option label="Đóng thừa" value="OVERPAID" />
            <el-option label="Đóng đủ thừa" value="FULLY_PAID_WITH_SURPLUS" />
            <el-option label="Đóng đủ thiếu" value="PAID_WITH_DEFICIT" />
          </el-select>
        </el-form-item>

        <el-form-item label="Trạng thái kết chuyển" class="mts-form-item">
          <el-select
              v-model="filter.transactionEntry"
              placeholder="Tất cả"
              clearable
              style="width: 170px"
              @change="fetchData"
          >
            <el-option label="Không chuyển" value="MONEY_WALLET" />
            <el-option label="Sang tháng sau" value="MONEY_MONTH" />
          </el-select>
        </el-form-item>

        <el-form-item label="Đợt thu" class="mts-form-item">
          <el-select
              v-model="filter.turn"
              placeholder="Tất cả"
              clearable
              style="width: 110px"
              @change="fetchData"
          >
            <el-option
                v-for="turn in 10"
                :key="turn"
                :value="turn"
                :label="`Đợt ${turn}`"
            />
          </el-select>
        </el-form-item>

        <el-form-item :label="filter.targetType === 'CLASS' ? 'Tên lớp' : 'Tên nhóm'" class="mts-form-item">
          <el-input
            v-if="filter.targetType === 'CLASS'"
            v-model="filter.className"
            placeholder="Tìm kiếm lớp..."
            clearable
            style="width: 220px"
            @keyup.enter.native="fetchData"
            @clear="fetchData"
          >
            <template #append>
              <el-button icon="el-icon-search" @click="fetchData" />
            </template>
          </el-input>
          <el-input
            v-if="filter.targetType === 'GROUP'"
            v-model="filter.groupName"
            placeholder="Tìm kiếm nhóm..."
            clearable
            style="width: 220px"
            @keyup.enter.native="fetchData"
            @clear="fetchData"
          >
            <template #append>
              <el-button icon="el-icon-search" @click="fetchData" />
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- Table Section -->
    <div class="row-data mts-table-card">
      <el-tabs
        v-model="filter.targetType"
        type="card"
        class="sk-tabs"
        @tab-click="handleTabChange"
      >
        <el-tab-pane name="CLASS">
          <template slot="label">
            <i class="el-icon-office-building" /> Theo lớp
          </template>
        </el-tab-pane>

        <el-tab-pane name="GROUP">
          <template slot="label">
            <i class="el-icon-collection" /> Theo nhóm
          </template>
        </el-tab-pane>

        <el-tab-pane name="PACKAGE">
          <template slot="label">
            <i class="el-icon-collection-tag" /> Theo gói
          </template>
        </el-tab-pane>
      </el-tabs>

      <div class="mts-table-wrapper">
        <el-table
          :data="tableData"
          :border="true"
          class="sk-table mts-main-table"
          style="width: 100%"
          v-loading="isLoading"
          show-summary
          :summary-method="getSummaries"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            align="center"
            width="55"
          />

          <el-table-column
            label="STT"
            type="index"
            width="50"
            align="center"
          />

          <el-table-column
            :label="filter.targetType === 'CLASS' ? 'Tên lớp' : (filter.targetType === 'GROUP' ? 'Tên nhóm' : 'Tên gói học phí')"
            prop="targetName"
            min-width="160"
          />

          <el-table-column
            label="Nợ/dư kỳ trước"
            prop="beforeMoneyTotal"
            align="right"
            min-width="130"
          >
            <template #default="{ row }">
              <span :class="row.beforeMoneyTotal < 0 ? 'mts-money--negative' : (row.beforeMoneyTotal > 0 ? 'mts-money--positive' : 'mts-money')">
                {{ row.beforeMoneyTotal | currency }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            label="Tổng phải thu"
            prop="sumMoneyTotal"
            align="right"
            min-width="130"
          >
            <template #default="{ row }">
              <span class="mts-money mts-money--bold">{{ row.sumMoneyTotal | currency }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Tổng đã thu"
            prop="collectedMoneyTotal"
            align="right"
            min-width="130"
          >
            <template #default="{ row }">
              <span class="mts-money mts-money--collected">{{ row.collectedMoneyTotal | currency }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Tiền mặt"
            prop="cashMoneyTotal"
            align="right"
            min-width="130"
          >
            <template #default="{ row }">
              <span class="mts-money">{{ row.cashMoneyTotal | currency }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Chuyển khoản"
            prop="transferMoneyTotal"
            align="right"
            min-width="130"
          >
            <template #default="{ row }">
              <span class="mts-money">{{ row.transferMoneyTotal | currency }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Nợ/dư còn lại"
            prop="afterMoneyTotal"
            align="right"
            min-width="130"
          >
            <template #default="{ row }">
              <span :class="row.afterMoneyTotal < 0 ? 'mts-money--negative' : (row.afterMoneyTotal > 0 ? 'mts-money--positive' : 'mts-money')">
                {{ row.afterMoneyTotal | currency }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="Trạng thái" align="center" width="120">
            <template #default="{ row }">
              <div
                class="sk-status-icon"
                :class="row.delActive ? 'success' : 'fail'"
                :title="row.delActive ? 'Đang hoạt động' : 'Đã ngừng'"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 16px; text-align: right;">
        <el-button
          type="success"
          icon="el-icon-download"
          :loading="loadingButton"
          @click="exportToExcelCurrent"
        >
          Xuất file Excel tổng hợp
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="openExportDialog"
        >
          Xuất file Excel chi tiết
        </el-button>
      </div>

      <ExportStudentStatisticDialog
        :show-dialog="showExportDialog"
        :filter-data="filter"
        :selected-list="selectedItems"
        @close="showExportDialog = false"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import TuitionStatisticService from "@/services/tutition_v3/TuitionStatisticService";
import { kidStatusListExcel } from "@/constant/listCommon";
import { exportToExcel } from "@/commonFuncion/ExportExcelFEOnly";
import ExportStudentStatisticDialog from "./dialog/ExportStudentStatisticDialog.vue";

export default {
  name: "ManagingTuitionStatistic",
  components: { ExportStudentStatisticDialog },
  data() {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    return {
      kidStatusListExcel,
      isLoading: false,
      loadingButton: false,
      showExportDialog: false,
      tableData: [],
      dateRange: [formatDate(firstDay), formatDate(lastDay)],
      filter: {
        startDate: formatDate(firstDay),
        endDate: formatDate(lastDay),
        targetType: "CLASS",
        status: null,
        turn: null,
        transactionEntry: null,
        className: null,
        groupName: null,
        packageName: null,
        statusTargetType: true,
        kidStatus: null,
        idGrade: null,
      },
      selectedItems: [],
    };
  },
  computed: {
    ...mapState("gradeModule", ["gradeOfSchoolList"]),
    ...mapGetters("schoolStore", ["schoolInfo"]),
    completeExportToExcelData() {
      const titleFile = this.filter.targetType === 'CLASS'
        ? 'THỐNG KÊ HỌC PHÍ THEO LỚP'
        : (this.filter.targetType === 'GROUP' ? 'THỐNG KÊ HỌC PHÍ THEO NHÓM' : 'THỐNG KÊ HỌC PHÍ THEO GÓI');
      const targetCol = this.filter.targetType === 'CLASS'
        ? 'Tên lớp'
        : (this.filter.targetType === 'GROUP' ? 'Tên nhóm' : 'Tên gói học phí');

      return {
        titleFile: titleFile,
        columnHeaders: [
          'STT', targetCol, 'Thiếu/Thừa tháng trước ', 'Phải thu tháng này',
          'Đã thu', 'Tiền mặt', 'Chuyển khoản', 'Thiếu thừa còn lại'
        ],
        columnWidths: [5, 30, 22, 20, 20, 20, 20, 20],
        nameFile: 'ThongKeHocPhi',
        companyInfo: this.schoolInfo,
        dataList: this.mapDataForTitle(),
      };
    }
  },
  async created() {
    await this.$store.dispatch("schoolStore/fetchDataSchoolData");
    await this.$store.dispatch("gradeModule/fetchDataGradeOfSchoolList");
    this.fetchData();
  },
  methods: {
    exportToExcel,
    handleSelectionChange(val) {
      this.selectedItems = val;
    },
    openExportDialog() {
      if (this.selectedItems.length === 0) {
        this.$message.warning("Vui lòng chọn ít nhất một đối tượng (lớp/nhóm) từ danh sách.");
        return;
      }
      this.showExportDialog = true;
    },
    handleReset() {
      const now = new Date();
      const firstDay = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`;
      const lastDayObj = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const lastDay = `${lastDayObj.getFullYear()}-${String(lastDayObj.getMonth() + 1).padStart(2, "0")}-${String(lastDayObj.getDate()).padStart(2, "0")}`;

      this.dateRange = [firstDay, lastDay];
      this.filter = {
        startDate: firstDay,
        endDate: lastDay,
        targetType: this.filter.targetType, // keep current tab
        status: null,
        turn: null,
        transactionEntry: null,
        className: null,
        groupName: null,
        packageName: null,
        statusTargetType: true,
        kidStatus: null,
        idGrade: null,
      };
      this.fetchData();
    },
    handleTabChange() {
      // Khi đổi tab, clear name search và idGrade
      this.filter.className = null;
      this.filter.groupName = null;
      this.filter.packageName = null;
      this.filter.idGrade = null;
      this.fetchData();
    },
    async fetchData() {
      // Gán startDate, endDate từ dateRange
      if (this.dateRange && this.dateRange.length === 2) {
        this.filter.startDate = this.dateRange[0];
        this.filter.endDate = this.dateRange[1];
      } else {
        this.$message.warning("Vui lòng chọn khoảng thời gian");
        return;
      }

      this.isLoading = true;

      // Xử lý chuyển đổi chuỗi rỗng "" thành null để tránh lỗi BE
      const payload = {};
      for (const key in this.filter) {
        if (this.filter[key] === "") {
          payload[key] = null;
        } else {
          payload[key] = this.filter[key];
        }
      }

      try {
        const response = await TuitionStatisticService.filterStatistic(payload);
        if (response.data && response.data.data) {
          this.tableData = response.data.data;
        } else {
          this.tableData = [];
        }
      } catch (error) {
        this.$message.error(error?.response?.data?.message || "Lỗi khi tải dữ liệu thống kê");
      } finally {
        this.isLoading = false;
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 2) {
          sums[index] = 'Tổng cộng';
          return;
        }
        // Column 1 is targetName, column 8 is delActive
        if (column.property !== 'beforeMoneyTotal' && 
            column.property !== 'sumMoneyTotal' && 
            column.property !== 'collectedMoneyTotal' && 
            column.property !== 'cashMoneyTotal' && 
            column.property !== 'transferMoneyTotal' && 
            column.property !== 'afterMoneyTotal') {
          sums[index] = '';
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          const total = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = Number(total).toLocaleString("vi-VN") + " ₫";
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    formatVND(number) {
      if (number === null || number === undefined || isNaN(number)) {
        return 0;
      }
      return number.toLocaleString('vi-VN');
    },
    mapDataForTitle() {
      return this.tableData.map((x, index) => [
        index + 1,
        x.targetName,
        this.formatVND(x.beforeMoneyTotal),
        this.formatVND(x.sumMoneyTotal),
        this.formatVND(x.collectedMoneyTotal),
        this.formatVND(x.cashMoneyTotal),
        this.formatVND(x.transferMoneyTotal),
        this.formatVND(x.afterMoneyTotal),
      ]);
    },
    calculateTotalMoney() {
      let a1 = 0, a2 = 0, a3 = 0, a4 = 0, a5 = 0, a6 = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        a1 += this.tableData[i].beforeMoneyTotal || 0;
        a2 += this.tableData[i].sumMoneyTotal || 0;
        a3 += this.tableData[i].collectedMoneyTotal || 0;
        a4 += this.tableData[i].cashMoneyTotal || 0;
        a5 += this.tableData[i].transferMoneyTotal || 0;
        a6 += this.tableData[i].afterMoneyTotal || 0;
      }
      return ['', 'Tổng cộng', this.formatVND(a1), this.formatVND(a2), this.formatVND(a3), this.formatVND(a4), this.formatVND(a5), this.formatVND(a6)];
    },
    exportToExcelCurrent() {
      if (this.tableData.length === 0) {
        this.$message.warning("Không có dữ liệu để xuất");
        return;
      }
      
      this.loadingButton = true;
      const columnBottoms = this.calculateTotalMoney();
      this.$confirm(
          "Bạn có chắc chắn muốn xuất file hiện tại?",
          "Thông báo!",
          {
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(async () => {
        await this.exportToExcel(this.completeExportToExcelData, columnBottoms);
      }).catch(() => {
      }).finally(() => {
        this.loadingButton = false;
      });
    }
  },
  filters: {
    currency(value) {
      if (value === null || value === undefined || isNaN(value)) return "0";
      return Number(value).toLocaleString("vi-VN") + " ₫";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-table.scss";

.mts-page {
  padding: 4px 0 24px;
  .row-data { margin-bottom: 20px; }
}

.mts-toolbar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 20px 24px;
}

.mts-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 20px 24px 16px;
}

.mts-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.mts-card-title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

.mts-card-subtitle {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.6;
  color: #64748b;
}

.mts-form-grid {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.mts-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/deep/ .mts-form-item .el-form-item__label {
  padding-bottom: 4px;
  font-size: 12.5px;
  color: #475569;
  font-weight: 600;
  line-height: 1.5;
}

.mts-table-wrapper {
  border-radius: 14px;
  overflow: hidden;
}

.mts-money {
  font-variant-numeric: tabular-nums;
  color: #475569;
  font-size: 13px;
}
.mts-money--bold { font-weight: 700; color: #1e293b; }
.mts-money--negative { color: #dc2626; font-weight: 600; font-size: 13px; font-variant-numeric: tabular-nums; }
.mts-money--positive { color: #16a34a; font-weight: 600; font-size: 13px; font-variant-numeric: tabular-nums; }
.mts-money--collected { color: #2563eb; font-weight: 600; font-size: 13px; font-variant-numeric: tabular-nums; }

/deep/ .sk-table thead th,
/deep/ .sk-table thead td {
  background: #2563eb !important;
  color: #ffffff !important;
  font-weight: 700;
}
/deep/ .sk-table thead th > .cell,
/deep/ .sk-table thead td > .cell {
  color: #ffffff !important;
  font-weight: 700;
}
/deep/ .sk-table thead tr { height: 52px; }
/deep/ .sk-table tbody td { background: #ffffff; }

/* Summary row */
/deep/ .el-table__footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #f0f9ff;
  color: #0957f4;
}
/deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #f0f9ff;
  color: #0957f4;
}

/deep/ .mts-page .el-input__inner,
/deep/ .mts-page .el-select .el-input__inner { border-radius: 10px; }
/deep/ .mts-page .el-button { border-radius: 10px; }

/deep/ .sk-tabs .el-tabs__nav {
  background: transparent;
  border: none;
}

/deep/ .sk-tabs .el-tabs__nav-wrap::after {
  background: #2563eb;
  height: 2px;
}

/deep/ .sk-tabs .el-tabs__item {
  background: #e5e7eb;
  color: #4b5563;
  font-weight: 600;
  border: 1px solid #d1d5db !important;
  border-bottom: none !important;
  border-radius: 8px 8px 0 0;
  transition: background 0.15s, color 0.15s;

  i { margin-right: 6px; }
}

/deep/ .sk-tabs .el-tabs__item:hover:not(.is-active) {
  background: #d1d5db;
  color: #1e293b;
}

/deep/ .sk-tabs .el-tabs__item.is-active {
  color: #ffffff !important;
  background: #2563eb !important;
  border-color: #2563eb !important;
}

/deep/ .sk-tabs .el-tabs__nav-scroll {
  float: right;
}

/deep/ .sk-tabs .el-tabs__header {
  margin-bottom: 0;
  border-bottom: none;
}

/deep/ .sk-tabs.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #2563eb;
}

/deep/ .sk-tabs.el-tabs--card > .el-tabs__header {
  border-bottom: none;
  margin-bottom: 0;
}
</style>
